import Cookies from "js-cookie";

export const recoverCart = () => {
  const cartToken = Cookies.get("cart");
  const params = new URLSearchParams(location.search);
  const recoverCart = params.get("cart");

  if(!recoverCart) return;

  window.heap?.track?.("Cart Recovery Requested");

  if(cartToken != recoverCart){
    window.heap?.track?.("Cart Recovery Needed");
    Cookies.set("cart", recoverCart, 14);
    if(location.pathname.indexOf("/cart") === 0){
      params.delete("cart");
      location = "/cart?" + params.toString();
    }
  }else{
    window.heap?.track?.("Cart Recovery Unessessary");
  }

}
